export default __webpack_public_path__ + "static/media/background-appoinment1.cf69af04.jpg";